import { observeComponents, registerLazyComponent } from '../libs/utils/ComponentUtil';

import {
    PhoneInput,
    CityRideProduct,
    ScrollableIndicator,
    PaymentDetails,
    HotelResultsMap,
    FlightResultsMatrix,
    Calendar,
    MonthCalendar,
    ScrollableCalendar,
    ScrollableMonthCalendar,
    BudgetSlider,
    SummaryEngine,
    ModuleEngine,
    FlightProducts,
    CookieMessage,
    DestinationList,
    FAQList,
    FAQItem,
    SearchHistory
} from '../libs/components';

/* Register Lazy Components */
registerLazyComponent('[data-component="PhoneInput"]', PhoneInput);
registerLazyComponent('[data-component="CityRideProduct"]', CityRideProduct);
registerLazyComponent('[data-component="ScrollableIndicator"]', ScrollableIndicator);
registerLazyComponent('[data-component="PaymentDetails"]', PaymentDetails);
registerLazyComponent('[data-component="HotelResultsMap"]', HotelResultsMap);
registerLazyComponent('[data-component="FlightResultsMatrix"]', FlightResultsMatrix);
registerLazyComponent('[data-component="Calendar"]', Calendar);
registerLazyComponent('[data-component="MonthCalendar"]', MonthCalendar);
registerLazyComponent('[data-component="ScrollableCalendar"]', ScrollableCalendar);
registerLazyComponent('[data-component="ScrollableMonthCalendar"]', ScrollableMonthCalendar);
registerLazyComponent('[data-component="BudgetSlider"]', BudgetSlider);
registerLazyComponent('[data-component="SummaryEngine"]', SummaryEngine);
registerLazyComponent('[data-component="ModuleEngine"]', ModuleEngine);
registerLazyComponent('[data-component="FlightProducts"]', FlightProducts);
registerLazyComponent('[data-component="CookieMessage"]', CookieMessage);
registerLazyComponent('[data-component="DestinationList"]', DestinationList);
registerLazyComponent('[data-component="FAQList"]', FAQList);
registerLazyComponent('[data-component="FAQItem"]', FAQItem);
registerLazyComponent('[data-component="SearchHistory"]', SearchHistory);

/* Observer document and connect components */
observeComponents();